var React = require('react');

function Ellipse (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"4","cy":"4.5","r":"4","fill":"#30A8FF"}));
}

Ellipse.defaultProps = {"width":"8","height":"9","viewBox":"0 0 8 9","fill":"none"};

module.exports = Ellipse;

Ellipse.default = Ellipse;
